export const RuleEngineConstants = {
    TICKET_PROCESSING_TAB: "Ticket Processing Rule",
    LIEN_PROCESS_TAB: "Lien Process Rule",
    TAB_SIZE: "small",
}